
import SwitchItem from "../../../../../componentsNew/Analises/SwitchItem";
import ContextTela from "../../../telaContext";
import DescricaoCriterio from "../DescricaoCriterio";
import { useContext } from "@wordpress/element";

function Criterio({ item, criterioSelecionado, onChange, botaoDeslizar = true }) {
    const { desktop } = useContext(ContextTela)
    return (
        <div className={`${desktop ? "w-5/6" : "w-full"} justify-start items-center gap-2 flex-col mt-[18px]`}>
            <SwitchItem botaoDeslizar={botaoDeslizar} texto={item?.titulo} otimizado={item?.otimizado} onChange={onChange} checked={item?.idCriterio == criterioSelecionado?.idCriterio} />
            {item?.idCriterio == criterioSelecionado?.idCriterio && <div className="ml-[38.93px] pl-1 pb-8 mt-[18px]">
                <DescricaoCriterio item={item} />
            </div>}


        </div>

    );
}

export default Criterio;